import type { ReactNode } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { PendingDecisionAudienceContext, seesPendingDecisions } from '@/lib/pending-decision-audience';

/** Staff see `PendingDecision` markers; families don't (see `seesPendingDecisions`). */
export function PendingDecisionAudience({ children }: { children: ReactNode }) {
  const { user, impersonation } = useAuth();
  const visible = seesPendingDecisions(user, impersonation?.originalUser ?? null);
  return (
    <PendingDecisionAudienceContext.Provider value={visible}>{children}</PendingDecisionAudienceContext.Provider>
  );
}
